
    //import * as Vue from 'vue';
    import { defineComponent } from 'vue';
    import * as bootstrap from "bootstrap";
    import axios, { AxiosResponse, AxiosRequestConfig } from 'axios';
    import Swal from 'sweetalert2/dist/sweetalert2.js';
    import * as dayjs from 'dayjs';
    import 'dayjs/locale/fr';
    import 'dayjs/locale/es';
    import 'dayjs/locale/pt';
    import 'dayjs/locale/de';
    import 'dayjs/locale/ar';
    import 'dayjs/locale/ru';
    import * as utc from 'dayjs/plugin/utc';
    dayjs.extend(utc);
    import * as localizedFormat from 'dayjs/plugin/localizedFormat';
    dayjs.extend(localizedFormat);
    import * as duration from 'dayjs/plugin/duration';
    dayjs.extend(duration);
    import * as relativeTime from 'dayjs/plugin/relativeTime';
    dayjs.extend(relativeTime);
    /*require('moment/locale/fr');
    require('moment/locale/es');
    require('moment/locale/pt');
    require('moment/locale/de');
    require('moment/locale/ar');
    require('moment/locale/ru');*/
    import LoginmodalComponent from '../../Views/login/LoginmodalComponent.vue';
    import NotifLoginComponent from '../../Views/login/NotifLoginComponent.vue';
    import RegistermodalComponent from '../../Views/login/RegisterComponent.vue';
    import ForgotpasswordComponent from '../../Views/login/ForgotpasswordComponent.vue';
    import DcpaginationComponent from '../../Views/Shared/dcpagination.vue';
    import MigrateaccountComponent from '../../Views/login/MigrateaccountComponent.vue';
    import DcpartitionsComponent from '../../Views/Shared/dcpartitions.vue';
    import DcconfigbodyComponent from '../../Views/Shared/dcconfigbody.vue';
    import HcaptchaComponent from '../../Views/Shared/hcaptcha.vue';
    import ProgressDetection from './../Shared/ProgressDetection.vue';
    import { mapState, mapActions } from 'pinia';
    import { useLoginStore } from './Stores/LoginStore';

    export enum typeuidetect { DEFAULT = 0, PILOTES = 1, AIDE = 2, PLANTAGE = 3, MONITORING = 4}

    export enum LandingPageID { CONFIGPAGE = 0, DRIVERSPAGE = 1, BSODPAGE = 2, MONITORINGPAGE = 3, REALTIMEMONITORINGPAGE = 4 };

    export class DCAPIConfCryptResult { 
        public idconfiguser: string = "";
        public service: typeuidetect = 0;
    }

    export class DCThemeRequest {
        public theme: string = "";
    }

    export class DCThemeResponse {
        public theme: string = "";
        public cssfiletime: string = "";
    }
   
    export default defineComponent({
        components: { ProgressDetection, NotifLoginComponent, LoginmodalComponent, RegistermodalComponent, ForgotpasswordComponent, DcpaginationComponent, DcpartitionsComponent, MigrateaccountComponent, DcconfigbodyComponent, HcaptchaComponent },
        data() {
            return {
                initmigrate: 0,
                theme: "",
                lang: "",
                dayjs: null as any,
                urlsearch: "",
                dcsearchinput: "",
                m_urlofflineconfig: "",
                m_urlofflinedrivers: "",
                m_urlofflinebsod: "",
                m_urlofflinemonitoring: "",
                m_urlrealtimemonitoring: "",
                progressconfigoffline: 0,
                isuploading: false,
                offline_isdragging: false,
                lastbreadcrumb: "",
                line2mobileactive: false,
                modalrgpd: null as any,
                breadcrumb: null
            };
        },
        computed: {
            ...mapState(useLoginStore, ['modeloginmodal', 'descloginreferer', 'modalconn','modejetable'])
        },
        mounted() {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
            if (!this.isTouchDevice()) {

                var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
                var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                    return new bootstrap.Tooltip(tooltipTriggerEl)
                });

            }
            else {
                $('[data-bs-toggle="tooltip"]').removeAttr("title");
            }
            if (this.initmigrate == 1) {
                this.initmigrate = 2;
               this.setmodeloginmodal(3);

                this.setdescloginreferer("");
                let elt = document.getElementById('dc_logindialog');
                if (elt !== null) {
                    let modal = new bootstrap.Modal(elt, {
                        backdrop: 'static',
                        keyboard: false
                    });
                    modal.show();
                }
            }
            this.InitFooter();
            this.InitLeftBarre();
            this.CorrectTouchIOS();
        },
       
        created() {
            this.dayjs = dayjs;
            let pageroot = document.getElementById("rootpage");
            window.addEventListener('scroll', this.handleScrollMain, { passive: true });
            window.addEventListener('resize', this.ResizeMain, { passive: true });
        },
        unmounted() {
            let pageroot = document.getElementById("rootpage");
            window.removeEventListener('scroll', this.handleScrollMain);
            window.removeEventListener('resize', this.ResizeMain);
        },
        methods:
        {
            ...mapActions(useLoginStore, ['DCOpenLoginModal', 'setmodeloginmodal', 'setdescloginreferer','DCCreateAccount']),
            CorrectTouchIOS() {
                if (this.isTouchDevice()) {
                    $('a').not('.contentactu a').on('touchstart', function () {
                        $(this).trigger('click');
                    });
                }
            },
            isTouchDevice() {
                return 'ontouchstart' in window || (window as any)['DocumentTouch'] && document instanceof (window as any)['DocumentTouch'];
            },
            InitFooter() {
                let scrolltop: number | undefined = $(window).scrollTop();
                if (scrolltop == null)
                    return;
                if (scrolltop == 0)
                    $('.dctop').css('display', 'none');
                else
                    $('.dctop').css('display', 'block');
                jQuery("a.dctop").click(function () {
                    jQuery("html, body").animate({ scrollTop: 0 }, "slow");
                    return false;
                });
            },
            InitLeftBarre(): void {
                jQuery(document).ready(function () {
                    let scrolltop: number | undefined = $(window).scrollTop();
                    if (scrolltop == null)
                        return;
                    let height = $('#dchabillage').height();
                    if (height == null)
                        return;
                    let auxheight = $('#topmargincadre').height();
                    if (auxheight != null)
                        height += auxheight;
                    if (scrolltop >= height)
                        $('.rightsidebar').css('top', 0);
                    else
                        $('.rightsidebar').css('top',height-scrolltop);
                    jQuery('#leftbarre').on('click', function (event) {
                        const target = event.target;
                        if (target.tagName.toLowerCase() !== 'a' && target.parentElement !== null && target.parentElement.tagName.toLowerCase() !== 'a') {
                            jQuery('.rightsidebar').toggleClass('active');
                            jQuery('#topbarre').toggleClass('sidebaractive');
                        }
                    });
                    jQuery(document).click(function (event) {
                        const $target = $(event.target);
                        if (!$target.closest('#leftbarre').length &&
                            jQuery('.rightsidebar').hasClass("active")) {
                            jQuery('.rightsidebar').toggleClass('active');
                            jQuery('#topbarre').toggleClass('sidebaractive');
                        }
                        if (!$target.closest('#panelheader').length && !$target.closest('#topbarre').length &&
                            jQuery('#panelheader').hasClass("stickedp")) {
                            jQuery('#panelheader').toggleClass('stickedp');
                        }
                    });
                });
            },

            SwitchSidebarMobile() {
                this.line2mobileactive = !this.line2mobileactive;
            },
            RecalcPanel() {
                let ltr: boolean = document.documentElement.className != "rtl";
                let offset = $("#topbarre").offset();
                let height = $("#topbarre").height();
                let width = $("#topbarre").width();
                let panelwidth = $("#panelheader").width();
                if (offset == null)
                    return;
                if (width == null)
                    return;
                if (height == null)
                    return;
                if (panelwidth == null)
                    return;
                $("#panelheader").css("top", offset.top + height);
                if (ltr)
                    $("#panelheader").css("left", offset.left + width - panelwidth);
                else
                    $("#panelheader").css("left", offset.left);
            },
            SwitchHeaderPanel() {
                this.RecalcPanel();
                let sticked: boolean = $("#panelheader").hasClass("stickedp");
                if (sticked) {
                    $("#panelheader").removeClass("stickedp");
                }
                else
                    $("#panelheader").addClass("stickedp");

            },
            OpenUrl(url: string) {
                window.location.href = url;
            },
            ResizeMain(event: any) {
                let vh = window.innerHeight * 0.01;
                document.documentElement.style.setProperty('--vh', `${vh}px`);
                this.RecalcPanel();
            },
            handleScrollMain(event: any) {
               // console.error("handleScrollMaindeb");
                let self = this;
                this.RecalcPanel();
                let scrolltop: number | undefined = $(window).scrollTop();
                if (scrolltop == null)
                    return;
                // console.error("handleScrollMaindeb  " + scrolltop);
                let height = $('#dchabillage').height();
                if (height == null)
                    return;
                let auxheight = $('#topmargincadre').height();
                if (auxheight!=null)
                    height += auxheight;
                if (scrolltop ==0)
                    $('.dctop').css('display', 'none');
                else
                    $('.dctop').css('display', 'block');
                if (scrolltop >= height)
                    $('.rightsidebar').css('top', 0);
                else
                    $('.rightsidebar').css('top', height - scrolltop);
               // console.error("handleScrollMain " + scrolltop + " " + offset.top);
                if (scrolltop >= height) {
                    $('#topbarre').addClass("stickeddesk");
                    $('#maincontent').addClass("stickeddesk");
                    $('#leftbarre .leftsidebar').addClass("stickeddesk");
                    $('#leftbarre .rightsidebar').addClass("stickeddesk");
                }
                else {
                    $('#topbarre').removeClass("stickeddesk");
                    $('#maincontent').removeClass("stickeddesk");
                    $('#leftbarre .leftsidebar').removeClass("stickeddesk");
                    $('#leftbarre .rightsidebar').removeClass("stickeddesk");
                }
                if (scrolltop > 90) {
                    //console.error("handleScrollMain sticked" );
                    $('#leftbarremobile').addClass("sticked");
                    $('#maincontent').addClass("sticked");
                 
                }
                else {
                    //console.error("handleScrollMain not sticked");
                    $('#leftbarremobile').removeClass("sticked");
                    $('#maincontent').removeClass("sticked");
                   
                }
               /* let scrolltop: number | undefined = $(window).scrollTop();
                if (scrolltop == null)
                    return;
                let offset = $('#rootpage').offset();
                if (offset == null)
                    return;
                if (scrolltop >= offset.top)
                    $('.rightsidebar').css('top', 0);
                else
                $('.rightsidebar').css('top', (offset.top - scrolltop));
                if (scrolltop > offset.top) {
                    $('#topbarre').addClass("sticked");
                    $('#leftbarre .leftsidebar').addClass("sticked");
                    $('#leftbarre .rightsidebar').addClass("sticked");
                    $('#mainpage').addClass("sticked");
                    $('#maincontent').addClass("sticked");
                }
                else {
                    $('#topbarre').removeClass("sticked");
                    $('#leftbarre .leftsidebar').removeClass("sticked");
                    $('#leftbarre .rightsidebar').removeClass("sticked");
                    $('#mainpage').removeClass("sticked");
                    $('#maincontent').removeClass("sticked");
                }*/
            },
            InitLocale(locale: string) {
                this.dayjs.locale(locale);
            },
             SetUrlSearch(url: string) {
                this.urlsearch = url;
            },

            SetLastBreadCrumb(lastbreadcrumb: string) {
                this.lastbreadcrumb = lastbreadcrumb;
            },
            InitTheme(theme: string) {
                if (this.theme=="")
                this.theme = theme;
            },
            InitLangue(langue: string) {
                if (this.lang == "")
                    this.lang = langue;
            },
            ChangeTheme(theme: string) {
                let themerequest: DCThemeRequest = new DCThemeRequest();
                themerequest.theme = theme;
                let self = this;
                axios.post<DCThemeResponse>("/api/v1.0/login/ChangeTheme", themerequest).then(function (response: AxiosResponse<DCThemeResponse>) {
                    if (response.data != null) {
                        let elt:any = document.getElementById("csstheme");
                        if (elt != null) {
                            elt.href = "/dist/" + theme + ".css?m=" + response.data.cssfiletime;
                        }
                        self.theme = theme;
                    }
                });
              
            },
            ChangeLangue(lan: string) {
                let self = this;
                axios.post<string>("/api/v1.0/login/ChangeLangue?lan=" + lan).then(function (response: AxiosResponse<string>) {
                    if (response.data != null) {
                        location.href = "/" + response.data;
                        }
                });

            },
            SetConfigurationUrl(urlofflineconfig: string, urlofflinedrivers: string, urlofflinebsod: string, urlofflinemonitoring: string, urlrealtimemonitoring:string) {
                this.m_urlofflineconfig = urlofflineconfig;
                this.m_urlofflinedrivers = urlofflinedrivers;
                this.m_urlofflinebsod = urlofflinebsod;
                 this.m_urlofflinemonitoring = urlofflinemonitoring;
                 this.m_urlrealtimemonitoring = urlrealtimemonitoring;
            },
            GetConfigurationUrl(typeservice: LandingPageID, id: string): string {
                if (typeservice == LandingPageID.BSODPAGE)
                    return this.m_urlofflinebsod.replace('%idconfig%', id);
                if (typeservice == LandingPageID.DRIVERSPAGE)
                    return this.m_urlofflinedrivers.replace('%idconfig%', id);
                if (typeservice == LandingPageID.MONITORINGPAGE)
                    return this.m_urlofflinemonitoring.replace('%idconfig%', id);
                if (typeservice == LandingPageID.REALTIMEMONITORINGPAGE)
                    return this.m_urlrealtimemonitoring.replace('%idconfig%', id);
                else
                    return this.m_urlofflineconfig.replace('%idconfig%', id);
            },

             selectFileHorsLigne() {
                document.getElementById("filecryptxml")?.click();
            },

            onFilePicked(event: any, uploadeddesc: string) {
                const files = event.target.files
                this.UploadHorsLigne(files[0], uploadeddesc);
            },

             offline_dragEnter(ev: any) {
                this.offline_isdragging = true;
            },

             offline_dragLeave(ev: any) {
                this.offline_isdragging = false;
            },

            UploadHorsLigne(file: any, uploadeddesc: string) {
                let ext: string = file.name.split('.').pop();
                if (ext != "mc" && ext != "dc")
                    return;
                let formData = new FormData();
                formData.append('filecryptxml', file);
                let self = this;
                let config: AxiosRequestConfig = {
                    onUploadProgress: function (progressEvent) {
                        if (progressEvent.total === null || progressEvent.total === 0) {
                            let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                            self.progressconfigoffline = percentCompleted;
                        } else {
                            self.progressconfigoffline = 0;
                        }
                    }
                }
                this.isuploading = true;
                self.progressconfigoffline = 0;
                axios.post<DCAPIConfCryptResult>("/api/DriversCloudApi/RecevoirConfigurationCrypte", formData, config).then(function (response: AxiosResponse<DCAPIConfCryptResult>) {
                    if (response.data.idconfiguser != "") {
                        Swal.fire({
                            toast: true,
                            position: 'top-end',
                            icon: 'success',
                            customClass: {
                                container: 'dctoastcontainer'
                            },
                            title: uploadeddesc,
                            showConfirmButton: false,
                            timer: 2500
                        });
                        switch (response.data.service) {
                            case typeuidetect.PILOTES:
                                location.href = self.m_urlofflinedrivers.replace("%idconfig%", response.data.idconfiguser.toString());
                                break;
                            case typeuidetect.PLANTAGE:
                                location.href = self.m_urlofflinebsod.replace("%idconfig%", response.data.idconfiguser.toString());
                                break;
                            case typeuidetect.MONITORING:
                                location.href = self.m_urlofflinemonitoring.replace('%idconfig%', response.data.idconfiguser.toString());
                                break;
                            case typeuidetect.DEFAULT:
                            case typeuidetect.AIDE:
                            default:
                                location.href = self.m_urlofflineconfig.replace("%idconfig%", response.data.idconfiguser.toString());
                        }


                    }
                    self.isuploading = false;
                });
            },

             UploadConfiguration(e: any,uploadeddesc:string) {
                let droppedFiles = e.dataTransfer.files[0];
                 this.UploadHorsLigne(droppedFiles, uploadeddesc);

            },

            DCOpenMigrateModal() {
                if (this.initmigrate!=0)
                    return;
                this.initmigrate = 1;
                this.setmodeloginmodal(3);
                this.setdescloginreferer("");
            },

            showRGPD(event: any) {
                if (event != null)
                    event.preventDefault();
                let elt = document.getElementById('dc_rgpddialog');
                if (elt !== null) {
                    this.modalrgpd = new bootstrap.Modal(elt, {});
                    this.modalrgpd.show();
                }
            },


             async DCLogout(event: any) {
                event.preventDefault();
                 const response: AxiosResponse<boolean> = await axios.post("/api/v1/login/logout", "");
                 let url = new URL(window.location.href);
                 const search = url.search;
                 url = new URL(`${url.protocol}//${url.host}/${this.lang}/`);
                 const params = new URLSearchParams(search);
                 params.set('connect', '0');
                 url.search = params.toString();
                 window.location.href = url.toString();
            },

            async DCDeleteAccountJetable() {
                await axios.delete("/api/v1/login/DCDeleteAccountJetable");
                let url = new URL(window.location.href);
                const search = url.search;
                url = new URL(`${url.protocol}//${url.host}/${this.lang}/`);
                const params = new URLSearchParams(search);
                params.set('connect', '0'); 
                url.search = params.toString();
                window.location.href = url.toString();
            },

            ReSendMailConfirmation(lan: string,textconfirm:string,texterror:string) {
                axios.post<boolean>("/api/v1/login/ReSendMailConfirmation?lan=" + lan, "").then(function (response: AxiosResponse<boolean>) {
                    if (response.data) {
                        Swal.fire({
                            toast: true,
                            position: 'top-end',
                            customClass: {
                                container:'dctoastcontainer'
                            },
                            icon: 'success',
                            title: textconfirm,
                            showConfirmButton: false,
                            timer: 2500
                        });
                    }
                    else {
                        Swal.fire({
                            toast: true,
                            position: 'top-end',
                            customClass: {
                                container: 'dctoastcontainer'
                            },
                            icon: 'error',
                            title: texterror,
                            showConfirmButton: false,
                            timer: 2500
                        });
                    }
                });
            },

             DCSearchKey(event: any) {
                if (event.which === 13)
                    $("#formsearch").submit();
            }
        }
    });
